import api from "../../api/cognito";
import qs from 'qs';
import { router } from "../../main";
import jwt_decode from 'jwt-decode';

const state = {
    id_token: window.localStorage.getItem('cognito_id_token'),
    refresh_token: window.localStorage.getItem('cognito_refresh_token'),
    userName: window.localStorage.getItem('cognito_username'),
    userGroups: window.localStorage.getItem('cognito_usergroups'),
    userEmail: window.localStorage.getItem('cognito_useremail'),
    accessLevel: window.localStorage.getItem('cognito_accesslevel')
};

const getters = {
    isLoggedIn: (state) => {
        return !!state.id_token
    },
    currentIdToken: (state) => {
        return state.id_token
    },
    currentRefreshToken: (state) => {
        return state.refresh_token
    },
    currentUserName: (state) => {
        return state.userName
    },
    currentUserGroups: (state) => {
        return state.userGroups
    },
    currentUserEmail: (state) => {
        return state.userEmail
    },
    currentAccessLevel: (state) => {
        return state.accessLevel
    }
};

const actions = {
    login: () => {
        api.login();
    },
    exchangeToken: ({commit},hash) => {
        const query = qs.parse(hash.search.replace("?",""))
        api.exchange_token(query.code, function(data){
            var decoded = jwt_decode(data['id_token'])
            // Set state
            commit('setIdToken', data['id_token']);
            commit('setRefreshToken', data['refresh_token'])
            commit('setUserGroups', decoded['cognito:groups'])
            commit('setUserName', decoded['cognito:username'])
            commit('setUserEmail', decoded['email'])
            var groups = decoded['cognito:groups']
            // Compute access level
            var accessLevel = "unknown"
            if(String(groups).toLowerCase().indexOf('admin')>-1){
                accessLevel =  "admin"
            } else if(String(groups).toLowerCase().indexOf('poweruser')>-1) {
                accessLevel = "poweruser"
            } else if(String(groups).toLowerCase().indexOf('readonly')>-1) {
                accessLevel =  "readonly"
            }
            console.log(`Logging access level from auth.js. : ${accessLevel}`) 
            commit('setAccessLevel',accessLevel)
            // Persist values in the local store
            window.localStorage.setItem('cognito_id_token',data['id_token']);
            window.localStorage.setItem('cognito_refresh_token',data['refresh_token']);
            window.localStorage.setItem('cognito_username',decoded['cognito:username']);
            window.localStorage.setItem('cognito_usergroups',decoded['cognito:groups']);
            window.localStorage.setItem('cognito_useremail',decoded['email']);
            window.localStorage.setItem('cognito_accesslevel',accessLevel)
            router.push('/metrics');
        })
    },
    updateToken: ({commit, dispatch}, data) => {
        if (data){
            //update data after refreshing token
            commit('setIdToken', data['id_token']);
            // Persist values in the local store
            window.localStorage.setItem('cognito_id_token', data['id_token']);
        } else {
            dispatch('sessionTimedOut')
        }
    },
    // finalizeLogin: ({commit}, hash) => {
    //     // Get token from the url and parse it using query string
    //     const query = qs.parse(hash.replace('#',''));
    //     // Decode token using jwt_decode
    //     console.log(`ID Token: ${query.id_token}`)
    //     var decoded = jwt_decode(query.id_token)
    //     console.log(decoded)
    //     // Set state
    //     commit('setToken',query.id_token);
    //     commit('setUserGroups',decoded['cognito:groups'])
    //     commit('setUserName',decoded['cognito:username'])
    //     commit('setUserEmail',decoded['email'])
    //     var groups = decoded['cognito:groups']
    //     // Compute access level
    //     var accessLevel = "unknown"
    //     if(String(groups).toLowerCase().indexOf('admin')>-1){
    //         accessLevel =  "admin"
    //     } else if(String(groups).toLowerCase().indexOf('poweruser')>-1) {
    //         accessLevel = "poweruser"
    //     } else if(String(groups).toLowerCase().indexOf('readonly')>-1) {
    //         accessLevel =  "readonly"
    //     }
    //     console.log(`Logging access level from auth.js. : ${accessLevel}`) 
    //     commit('setAccessLevel',accessLevel)
    //     // Persist values in the local store
    //     window.localStorage.setItem('cognito_id_token',query.id_token);
    //     window.localStorage.setItem('cognito_refresh_token',query.refresh_token);
    //     window.localStorage.setItem('cognito_username',decoded['cognito:username']);
    //     window.localStorage.setItem('cognito_usergroups',decoded['cognito:groups']);
    //     window.localStorage.setItem('cognito_useremail',decoded['email']);
    //     window.localStorage.setItem('cognito_accesslevel',accessLevel)
    //     router.push('/')
    // },
    logout: ({ commit }) => {
        // Logout function to handle when user clicks on logout button
        console.log("Logout action got triggered.")
        commit('setIdToken', null);
        commit('setRefreshToken', null)
        commit('setUserGroups',null)
        commit('setUserName',null)
        commit('setUserEmail',null)
        commit('setLoggedIn',null)
        // remove values from local storage
        window.localStorage.removeItem('cognito_id_token')
        window.localStorage.removeItem('cognito_refresh_token')
        window.localStorage.removeItem('cognito_accesslevel')
        window.localStorage.removeItem('cognito_username')
        window.localStorage.removeItem('cognito_usergroups')
        window.localStorage.removeItem('cognito_useremail')
        console.log("Cleared local storage")
        console.log(window.localStorage)
        // Trigger logout action to invalidate session on cognito and adfs
        api.logout()
    },
    sessionTimedOut: ({ commit }) => {
        // This gets triggered with the session (id_token) expires
        console.log("Session Timeout action got triggered.")
        commit('setIdToken', null);
        commit('setRefreshToken', null)
        commit('setUserGroups',null)
        commit('setUserName',null)
        commit('setUserEmail',null)
        commit('setAccessLevel',null)
        // Remove values from localStorage
        window.localStorage.removeItem('cognito_id_token')
        window.localStorage.removeItem('cognito_refresh_token')
        window.localStorage.removeItem('cognito_accesslevel')
        window.localStorage.removeItem('cognito_username')
        window.localStorage.removeItem('cognito_usergroups')
        window.localStorage.removeItem('cognito_useremail')
        console.log("Cleared local storage")
        console.log(window.localStorage)
        // Redirect to session timedout page
        router.push('/loggedOut')
    },
    async storeInitializer ({ commit, state }) {
        console.log("Store Initialization got triggered")
        var result = await api.get_from_local_storage('cognito_id_token')
        commit('setIdToken',result)
        var result = await api.get_from_local_storage('cognito_refresh_token')
        commit('setRefreshToken',result)
        var result = await api.get_from_local_storage('cognito_accesslevel')
        commit('setAccessLevel',result)
        result = await api.get_from_local_storage('cognito_username')
        commit('setUserName',result)
        result = await api.get_from_local_storage('cognito_usergroups')
        commit('setUserGroups',result)
        result = await api.get_from_local_storage('cognito_useremail')
        commit('setUserEmail',result)
        result = await api.get_from_local_storage('cognito_loggedIn')
        commit('setLoggedIn',result)
        return state
    }
};

const mutations = {
    setIdToken: (state, token) => {
        state.id_token = token;
    },
    setRefreshToken: (state, token) => {
        state.refresh_token = token;
    },
    setUserName: (state, userName) => {
        state.userName = userName;
    },
    setUserGroups: (state, userGroup) => {
        state.userGroups = userGroup;
    },
    setUserEmail: (state, userEmail) => {
        state.userEmail = userEmail;
    },
    setAccessLevel: (state, accessLevel) => {
        state.accessLevel = accessLevel
    }

};

export default {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};
